/**
 * Shared text style for the body cells of every dashboard stats modal
 * (SMS, Emails, Calls, Web Activity, Handoffs, etc). Set on the table
 * wrapper inside StatsModal so cells inherit consistent sizing by
 * default; compose with `cn()` when a cell needs to layer extra styles
 * on top (e.g. a name link still picks up `text-primaryfortext` /
 * `underline` while keeping the same size).
 *
 * Targets `<td>` descendants directly with `!important` because the
 * speculo-ui Table applies its own `text-xs` / `md:text-sm` to each
 * cell — parent font-size would never reach the actual cell otherwise.
 * Cell children that don't set their own text-size inherit from the
 * <td> as usual.
 *
 * Three tiers so each form-factor reads natively:
 *   mobile               → 12px (text-xs)
 *   sm – xl (laptops)    → 13px
 *   2xl+ (large monitor) → 14px (text-sm)
 */
export const STAT_CELL_TEXT =
  '[&_tbody_td]:!text-xs sm:[&_tbody_td]:!text-[12px] 2xl:[&_tbody_td]:!text-[13px] text-foreground';
